const TOKEN_KEY = 'auth.token';

/**
 * Class representing AuthService
 * @memberOf services.auth
 * @ngdoc service
 * @name AuthService
 */
class AuthService {
  constructor($window) {
    /**
     * @type {service}
     * @memberOf AuthService
     * @description Instance of Angular $window service
     */
    this.$window = $window;
    this.accepted = false;
  }

  /**
   * @memberOf AuthService
   * @description Check to see if user is logged in but checking expiration date of token
   * @returns {boolean} True if expiration date is after current time, false otherwise
   */
  isLoggedIn() {
    let token;
    token = this.getToken();
    if (token) {
      let expiry = this.getExpiry(token);
      let isLoggedIn = this.checkExpiry(expiry);
      return isLoggedIn ? true : false;
    } else {
      return false;
    }
  }

  /**
   * @memberOf AuthService
   * @description Check to see if user is logged in, then retrieve user token information
   * @returns {string} payload of user token, if user is logged in
   */
  currentUser() {
    if (this.isLoggedIn()) {
      let token = this.getToken();
      let payload = token.split('.')[1];
      payload = this.$window.atob(payload);
      payload = JSON.parse(payload);
      return payload;
    }
  }

  /**
   * @memberOf AuthService
   * @description Set user session token
   * @param {string} token
   */
  setToken(token) {
    this.$window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  /**
   * @memberOf AuthService
   * @description Remove user session token
   */
  cleanToken() {
    this.$window.sessionStorage.removeItem(TOKEN_KEY);
    this.$window.sessionStorage.removeItem('auth.accepted');
  }

  /**
   * @memberOf AuthService
   * @description Retrieve user session token
   * @returns {string} token
   */
  getToken() {
    var token;
    token = this.$window.sessionStorage.getItem(TOKEN_KEY);
    return token;
  }

  /**
   * @memberOf AuthService
   * @description Gets the expiration date of the token
   * @param {string} token
   * @returns {Date} payload.exp
   */
  getExpiry(token) {
    let payload;
    payload = token.split('.')[1];
    payload = this.$window.atob(payload);
    payload = JSON.parse(payload);
    return payload.exp;
  }

  /**
   * @memberOf AuthService
   * @description Checks see if the token has expired
   * @param {Date} expiration date
   * @returns {Boolean}
   */
  checkExpiry(exp) {
    return exp > Date.now() / 1000;
  }

  /**
   * @memberOf AuthService
   * @description Sets that the user has accepted the disclaimer in session storage
   */
  setDisclaimerAccepted() {
    this.$window.sessionStorage.setItem('auth.accepted', true);
  }

  /**
   * @memberOf AuthService
   * @description Checks to see if that user has accepted the disclaimer but checking in session storage
   * @returns {Boolean}
   */
  disclaimerAccepted() {
    if (this.$window.sessionStorage.getItem('auth.accepted')) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * @memberOf AuthService
   * @description Removes the acceptance of the disclaimer from session storage
   */
  removeAccepted() {
    this.$window.sessionStorage.removeItem('auth.accepted');
  }

}

export default angular.module('services.auth', [])
  .service('AuthService', AuthService)
  .name;

AuthService.$inject = ['$window'];




// WEBPACK FOOTER //
// ./src/client/app/services/auth.service.js